import { render, staticRenderFns } from "./UyapStatusCard.vue?vue&type=template&id=7e5195aa&scoped=true"
import script from "./UyapStatusCard.vue?vue&type=script&lang=ts"
export * from "./UyapStatusCard.vue?vue&type=script&lang=ts"
import style0 from "./UyapStatusCard.vue?vue&type=style&index=0&id=7e5195aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5195aa",
  null
  
)

export default component.exports